import React from 'react'

export default function Loading() {
  return (
    <div className='text-center my-3'>
      <h2>Loading...</h2>
    </div>
  )
}